// Turks (tr-TR), timePicker: zelfde vorm als timePicker.nl.ts. Wat ontbreekt valt terug op het
// Nederlands (nooit een rauwe sleutel op het scherm).
export const appTimePickerTr = {
    open: '{label}: saat seç',
    hourStep: 'Saati seç',
    minuteStep: 'Dakikayı seç',
    hours: 'Saatler',
    minutes: 'Dakikalar',
    showNight: 'Gece 00–05',
    back: 'Başka saat',
    close: 'Kapat',
    type: 'Kendin yaz',
    invalid: 'Bu bir saat değil. Örneğin 15:30 ya da 930 yaz.',
    beforeStart: '{start} sonrası bir saat seç.',
    endClamped: 'Bitiş saati 23:59 olarak kısaltıldı.',
    durations: 'Ne kadar sürüyor?',
    orPickEnd: 'Ya da bir bitiş saati seç',
    durationUntil: '{duration}, {time} saatine kadar',
    minutesShort: '{count} dk',
    hoursShort: { one: '{count} saat', other: '{count} saat' },
};
//# sourceMappingURL=timePicker.tr.js.map